import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Switch } from 'react-router';
import { BrowserRouter, Route } from 'react-router-dom';
import store from './store/store';
import HomeContainer from './containers/home';
import AdminContainer from './containers/admin';
import { polyfill } from 'es6-promise';


// Polyfill promises.
polyfill();

let $content: Element = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route path="/admin" component={AdminContainer} />
        <Route path="/" component={HomeContainer} />
      </Switch>
    </BrowserRouter>
  </Provider>,
  $content
);


// WEBPACK FOOTER //
// ./source/ts/index.tsx